export default __webpack_public_path__ + "static/media/wild-hunter.55c1bb51.png";